"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultWalletApplicationWrapper = void 0;
exports.defaultWalletApplicationWrapper = {
    groupInfo: {},
    supportedCurrencies: [],
    tokenList: [],
    supportedNetworks: [],
    currencyPairs: [],
    filteredAssets: [],
    userProfile: {},
    authToken: "",
    walletWrapperInitialized: false,
    fromInfo: undefined,
    toInfo: undefined,
    availableLiquidity: "",
    amount: 0,
    fee: 0,
    maxBalance: 0,
    networkTransactions: [],
    providers: [],
};
// export interface DEFAULT_CURRENCIES {
//   currencies: Array<any>;
// }
// export const defaultCurrencies: DEFAULT_CURRENCIES = {
//   currencies: [],
// };
// export interface DEFAULT_TOKENS {
//   tokens: Array<any>;
// }
// export const defaultTokens: DEFAULT_TOKENS = {
//   tokens: [],
// };
//# sourceMappingURL=walletApplicationWrapperInterfaces.js.map